import axios from 'axios';

export default {
  name: 'VueCalculateMyseed',
  data() {
    return {
      certificate: '',
      currentStep: 0,
      domainUrl: '',
      fields: {},
      info: {},
      results: {},
      seedlotImage: {},
      seedlotTitle: '',
      seedlotSize: '',
      seedlotGRate: '',
      seedlotNumber: '',
      showNoResultsMessage: false,
      showSeedLotData: false,
      steps: [],
      submitted: false,
    };
  },
  computed: {
    totalSteps() {
      return this.steps.length;
    },
    isFirstStep() {
      return this.currentStep === 0;
    },
    isLastStep() {
      return this.currentStep === this.totalSteps - 1;
    },
  },
  created() {
    const config = {
      params: {
        type: 'myseed-certificate',
      },
    };

    // Get domain URL from main div attribute.
    this.domainUrl = document
      .getElementById('myseed-certificate')
      .getAttribute('data-domain-url');

    // Get seedlot number from main div attribute.
    this.seedlotNumber = document
      .getElementById('myseed-certificate')
      .getAttribute('data-seedlot-number');

    const url = `${this.domainUrl}/calculator/steps-fields/`;
    axios
      .get(url, config)
      .then((response) => {
        this.fields = response.data.fields || {};
        this.steps = response.data.steps || [];
      })
      .then(() => {
        if (this.seedlotNumber) {
          this.getSeedLot({ target: { value: this.seedlotNumber } });
        }
      })
      .catch((e) => {
        console.log(e);
      });
  },
  methods: {
    getPlaceholder(field) {
      return field.attributes && field.attributes.placeholder
        ? field.attributes.placeholder
        : null;
    },
    getInputDescription(field) {
      return field.attributes && field.attributes.description
        ? field.attributes.description
        : null;
    },
    getSeedLot(event) {
      const seedLotNumber = event.target.value;
      // If a 9 or 10 digits number is provided.
      if (seedLotNumber.length >= 9) {
        const config = {
          params: {
            variety_id: null,
            seedlot_number: seedLotNumber,
          },
        };
        // Search seedlot.
        const url = `${this.domainUrl}/calculator/seedlot`;
        axios
          .get(url, config)
          .then((response) => {
            const seedlot = response.data;
            if (Object.keys(seedlot).length) {
              this.certificate = seedlot.certificate_src || '';
              this.showSeedLotData = true;
              this.seedlotImage = {
                src: seedlot.variety.image,
                alt: seedlot.variety.label,
                text: seedlot.variety.text,
              };
              this.seedlotTitle = seedlot.variety.label;
              this.seedlotSize = seedlot.seed_size_display;
              this.seedlotGRate = seedlot.germination_rate;
              this.showNoResultsMessage = false;
            } else {
              this.cleanSeedLotData();
              this.showNoResultsMessage = true;
            }
          })
          .catch((e) => {
            console.log(e);
            this.cleanSeedLotData();
            this.showNoResultsMessage = true;
          });
      } else {
        this.cleanSeedLotData();
      }
    },
    isRequired(field) {
      return field.attributes && field.attributes.required;
    },
    isReadOnly(field) {
      return field.attributes && field.attributes.readonly;
    },
    maxLength(field) {
      return field.attributes && field.attributes.maxlength
        ? field.attributes.maxlength
        : null;
    },
    isArray(value) {
      return Array.isArray(value);
    },
    cleanSeedLotData() {
      this.certificate = '';
      this.seedlotImage = {};
      this.seedlotTitle = '';
      this.seedlotSize = '';
      this.seedlotGRate = '';
      this.showSeedLotData = false;
      this.showNoResultsMessage = false;
    },
    download() {
      if (!this.certificate) {
        return;
      }

      window.open(this.certificate, '_blank');
    },
  },
};
